import React, { memo } from 'react';

const ArrowSimpleInner = () => (
    <svg viewBox="0 0 16 9">
        <path d="M15.2071 8.20711C14.8166 8.59763 14.1834 8.59763 13.7929 8.20711L8 2.41421L2.20711 8.20711C1.81658 8.59763 1.18342 8.59763 0.792893 8.20711C0.402368 7.81658 0.402368 7.18342 0.792893 6.79289L7.29289 0.292894C7.68342 -0.0976308 8.31658 -0.0976308 8.70711 0.292894L15.2071 6.79289C15.5976 7.18342 15.5976 7.81658 15.2071 8.20711Z" />
    </svg>
);

export const ArrowSimple = memo(ArrowSimpleInner);
